export default __webpack_public_path__ + "static/media/img1.cc44c523.jpg";